$(document).ready(function () {
  $(document).on("click", "[data-pdp-v1-cta-scroll]", function (e) {
    var target = document.querySelector(".pdp-v1-product__info");

    if (!target) {
      return;
    }

    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  function syncPdpV1GalleryActiveThumb($gallery) {
    var track = $gallery.find("[data-pdp-v1-gallery-track]")[0];

    if (!track || !track.clientWidth) {
      return;
    }

    var index = Math.round(track.scrollLeft / track.clientWidth);

    if ($gallery.data("pdpV1ActiveThumbIndex") === index) {
      return;
    }

    $gallery.data("pdpV1ActiveThumbIndex", index);

    $gallery.find("[data-pdp-v1-gallery-thumb]").each(function () {
      var $thumb = $(this);
      var thumbIndex = parseInt($thumb.attr("data-pdp-v1-gallery-index"), 10);
      var isActive = thumbIndex === index;

      $thumb.toggleClass("pdp-v1-product__thumb--active", isActive);

      if (isActive) {
        this.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    });
  }

  $("[data-pdp-v1-gallery-track]").each(function () {
    var $track = $(this);

    $track.on("scroll", function () {
      syncPdpV1GalleryActiveThumb($track.closest(".pdp-v1-product__gallery"));
    });
  });

  $(document).on("click", "[data-pdp-v1-gallery-thumb]", function () {
    var $thumb = $(this);
    var $gallery = $thumb.closest(".pdp-v1-product__gallery");
    var track = $gallery.find("[data-pdp-v1-gallery-track]")[0];
    var index = parseInt($thumb.attr("data-pdp-v1-gallery-index"), 10);
    var slide = $gallery.find("[data-pdp-v1-gallery-slide]").get(index);

    if (track && slide) {
      track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
    }

    $gallery.data("pdpV1ActiveThumbIndex", index);
    $gallery.find("[data-pdp-v1-gallery-thumb]").removeClass("pdp-v1-product__thumb--active");
    $thumb.addClass("pdp-v1-product__thumb--active");
  });

  $(document).on("click", "[data-pdp-v1-accordion-item] > summary", function (e) {
    e.preventDefault();

    var $details = $(this).parent();
    var $body = $details.children("div").first();
    var isOpen = $details.attr("open") !== undefined;
    var groupName = $details.attr("name");

    if (isOpen) {
      $body.stop(true, true).slideUp(200, function () {
        $details.removeAttr("open");
      });
      return;
    }

    if (groupName) {
      $('[data-pdp-v1-accordion-item][name="' + groupName + '"][open]').each(function () {
        var $openDetails = $(this);
        var $openBody = $openDetails.children("div").first();

        $openBody.stop(true, true).slideUp(200, function () {
          $openDetails.removeAttr("open");
        });
      });
    }

    $details.attr("open", "");
    $body.hide().slideDown(200);
  });

  $(document).on("click", ".pdp-v1-media", function () {
    var $media = $(this);
    var video = $media.find("video")[0];

    if (!video) {
      return;
    }

    if (video.paused) {
      video.muted = true;
      $media.addClass("is-muted");
      video.play();
      $media.addClass("is-playing");
    } else {
      video.pause();
      $media.removeClass("is-playing");
    }
  });

  $(document).on("click", ".pdp-v1-media__mute", function (e) {
    e.stopPropagation();

    var $media = $(this).closest(".pdp-v1-media");
    var video = $media.find("video")[0];

    if (!video) {
      return;
    }

    video.muted = !video.muted;
    $media.toggleClass("is-muted", video.muted);
  });

  function autoplayVideosInView() {
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();

    $("[data-pdp-v1-autoplay-in-view]").each(function () {
      var $media = $(this);

      if ($media.data("pdpV1Autoplayed")) {
        return;
      }

      var elementTop = $media.offset().top;
      var elementBottom = elementTop + $media.outerHeight();

      if (windowBottom > elementTop && windowTop < elementBottom) {
        var video = $media.find("video")[0];

        if (video) {
          video.play();
        }

        $media.addClass("is-playing");
        $media.data("pdpV1Autoplayed", true);
      }
    });
  }

  autoplayVideosInView();
  $(window).on("scroll resize", autoplayVideosInView);

  function stopAllUgcVideos() {
    $("[data-pdp-v1-ugc-cell]").each(function () {
      var $cell = $(this);
      var video = $cell.find("[data-pdp-v1-ugc-video]")[0];

      if (video) {
        video.pause();
        video.muted = true;
      }

      $cell.removeClass("is-playing");
    });
  }

  $(document).on("mouseenter", "[data-pdp-v1-ugc-cell]", function () {
    var $cell = $(this);
    var video = $cell.find("[data-pdp-v1-ugc-video]")[0];

    $("[data-pdp-v1-ugc-cell]").not($cell).each(function () {
      var $other = $(this);
      var otherVideo = $other.find("[data-pdp-v1-ugc-video]")[0];

      if (otherVideo) {
        otherVideo.pause();
        otherVideo.muted = true;
      }

      $other.removeClass("is-playing");
    });

    if (video && video.paused) {
      video.play();
      $cell.addClass("is-playing");
    }
  });

  $(document).on("mouseleave", "[data-pdp-v1-ugc-row]", function () {
    stopAllUgcVideos();
  });

  $(window).on("scroll", stopAllUgcVideos);

  $(document).on("click", "[data-pdp-v1-ugc-video]", function () {
    var video = this;
    var $cell = $(this).closest("[data-pdp-v1-ugc-cell]");

    if (video.paused) {
      video.muted = false;
      video.play();
      $cell.addClass("is-playing");
      return;
    }

    if (video.muted) {
      video.muted = false;
      return;
    }

    video.pause();
    $cell.removeClass("is-playing");
  });

  $(document).on("click", ".pdp-v1-product__addcart", function () {
    var $button = $(this);

    $button.addClass("loading");

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      var stopLoading = function () {
        $button.removeClass("loading");
        unsubscribeCartUpdate();
        unsubscribeCartError();
      };

      var unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, stopLoading);
      var unsubscribeCartError = subscribe(PUB_SUB_EVENTS.cartError, stopLoading);
    }

    setTimeout(function () {
      $button.removeClass("loading");
    }, 8000);
  });

  function syncPdpV1KachingPrice() {
    var $selectedBar = $(".pdp-v1-product__kaching .kaching-bundles__bar--selected");

    if (!$selectedBar.length) {
      return;
    }

    var priceText = $selectedBar.find(".kaching-bundles__bar-price").first().text().trim();
    var comparePriceText = $selectedBar.find(".kaching-bundles__bar-full-price").first().text().trim();

    if (!priceText) {
      return;
    }

    $(".pdp-v1-product__price").text(priceText);

    var priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ""));
    var compareValue = parseFloat(comparePriceText.replace(/[^0-9.]/g, ""));

    if (comparePriceText && compareValue > priceValue) {
      $(".pdp-v1-product__compare-price").text(comparePriceText).show();

      var savingsPercentage = Math.round(((compareValue - priceValue) / compareValue) * 100);
      $(".pdp-v1-product__save-badge").text("You save " + savingsPercentage + "%").show();
    } else {
      $(".pdp-v1-product__compare-price").hide();
      $(".pdp-v1-product__save-badge").hide();
    }
  }

  var pdpV1KachingSyncTimer = null;

  function schedulePdpV1KachingSync() {
    clearTimeout(pdpV1KachingSyncTimer);
    requestAnimationFrame(syncPdpV1KachingPrice);
    pdpV1KachingSyncTimer = setTimeout(syncPdpV1KachingPrice, 100);
    setTimeout(syncPdpV1KachingPrice, 300);
  }

  $(document).on("click", ".pdp-v1-product__kaching .kaching-bundles__bar", schedulePdpV1KachingSync);
  $(document).on("change", ".pdp-v1-product__kaching .kaching-bundles__bar-variant-select", schedulePdpV1KachingSync);

  var pdpV1KachingRoot = document.querySelector(".pdp-v1-product__kaching");

  if (pdpV1KachingRoot && window.MutationObserver) {
    var pdpV1KachingObserver = new MutationObserver(schedulePdpV1KachingSync);

    pdpV1KachingObserver.observe(pdpV1KachingRoot, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  schedulePdpV1KachingSync();

  function fillCompareBars() {
    var windowBottom = $(window).scrollTop() + $(window).height();

    $(".pdp-v1-compare").each(function () {
      var $compare = $(this);

      if ($compare.data("pdpV1Filled")) {
        return;
      }

      if (windowBottom > $compare.offset().top) {
        $compare.addClass("pdp-v1-compare--in-view");
        $compare.data("pdpV1Filled", true);
      }
    });
  }

  fillCompareBars();
  $(window).on("scroll resize", fillCompareBars);
});
